import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
})
export class TabsComponent implements OnInit {
  @Input() public big = [];
  get isBig() {
    return (
      this.big.filter((b) => document.location.pathname.includes(b)).length > 0
    );
  }

  constructor() {}

  ngOnInit(): void {}
}
